import type { CustomerOrder } from '@inktap/contracts/customer-orders';

// This is only the initial admission check; the server makes the final decision.
export const canReviewPendingOrder = (order: CustomerOrder) =>
  order.status === 'PENDING' && ['UNPAID', 'CHECKOUT_OPEN', 'FAILED'].includes(order.paymentState);
